import { render } from "./fleet.cattle.io.bundle.vue?vue&type=template&id=0670d859"
import script from "./fleet.cattle.io.bundle.vue?vue&type=script&lang=js"
export * from "./fleet.cattle.io.bundle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__